import "./LabAttachmentsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../shared/services";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import LabAttachmentsViewComponent from "./lab-attachments-view/LabAttachmentsViewComponent";
import LabAttachmentsEditComponent from "./lab-attachments-edit/LabAttachmentsEditComponent";
import StatusCardComponent from "../../../../shared/components/status-card/statusCardComponent";
import {ImageConfig} from "../../../../constants";
import LottieFileGenarationComponent
    from "../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";

interface LabAttachmentsComponentProps {
    labDetails: any;
    onModeChange: any;
    canEdit: boolean;
}

const LabAttachmentsComponent = (props: LabAttachmentsComponentProps) => {
    const {labDetails, onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [labAttachmentsList, setLabAttachmentsList] = useState<any>([]);
    const [isLabAttachmentsListLoading, setIsLabAttachmentsListLoading] = useState<boolean>(false);
    const [isLabAttachmentsListLoaded, setIsLabAttachmentsListLoaded] = useState<boolean>(false);
    const [isLabAttachmentsListLoadingFailed, setIsLabAttachmentsListLoadingFailed] = useState<boolean>(false);

    const handleAttachmentUpdate = useCallback((updatedLabAttachments: any) => {
        setLabAttachmentsList(updatedLabAttachments);
        setMode("view");
    }, []);

    const getLabAttachmentsList = useCallback(() => {
        setIsLabAttachmentsListLoading(true);
        setIsLabAttachmentsListLoaded(false);
        setIsLabAttachmentsListLoadingFailed(false);
        const payload = {}
        CommonService._lab.getLabAttachments(labDetails?.id, payload)
            .then((response: IAPIResponseType<any>) => {
                if (response?.data) {
                    setLabAttachmentsList(response.data);
                }
                setIsLabAttachmentsListLoading(false);
                setIsLabAttachmentsListLoaded(true);
                setIsLabAttachmentsListLoadingFailed(false);
            })
            .catch((error: any) => {
                setIsLabAttachmentsListLoading(false);
                setIsLabAttachmentsListLoaded(false);
                setIsLabAttachmentsListLoadingFailed(true);
            });
    }, [labDetails])

    const handleLabAttachmentsEditCancel = useCallback(() => {
        setMode("view");
    }, []);

    useEffect(()=>{
        onModeChange(mode)
    },[mode,onModeChange]);

    useEffect(() => {
        if (labDetails.id) {
            getLabAttachmentsList();
        }
    }, [labDetails, getLabAttachmentsList]);


    return (
        <div className="patient-information-component details-tab-data-wrapper">
            {
                isLabAttachmentsListLoading && <div className="details-screen-loading-icon h-v-center">
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
            {
                isLabAttachmentsListLoadingFailed && <div className="bg-color-white">
                    <StatusCardComponent title={"Lab Attachments failed to load"}/>
                </div>
            }
            {
                isLabAttachmentsListLoaded && <>
                    {
                        mode === "view" && <LabAttachmentsViewComponent
                            labAttachments={labAttachmentsList}
                            canEdit={canEdit}
                            onEditModeOpen={() => {
                                setMode("edit")
                            }}
                        />
                    }
                    {
                        mode === "edit" && <LabAttachmentsEditComponent
                            onEditCancel={() => {
                                handleLabAttachmentsEditCancel()
                            }}
                            labID={labDetails.id}
                            labAttachments={labAttachmentsList}
                            onUpdateComplete={handleAttachmentUpdate}
                        />
                    }
                </>
            }
        </div>
    )

};

export default LabAttachmentsComponent;
